import { render, staticRenderFns } from "./ContactListSideMenu.vue?vue&type=template&id=f0843444"
import script from "./ContactListSideMenu.vue?vue&type=script&lang=js"
export * from "./ContactListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports